import { useHMSScreenShareVideo } from "../hms";
import { useLivekitScreenShareVideo } from "../livekit";
import type { ProviderScreenShareVideo } from "../types";
import { useProviderHook } from "./useProviderHook";

export const useProviderScreenShareVideo = (): ProviderScreenShareVideo =>
  useProviderHook({
    hms: useHMSScreenShareVideo,
    livekit: useLivekitScreenShareVideo,
  })();
